import { render, staticRenderFns } from "./mailSettingGet.vue?vue&type=template&id=403df957&scoped=true&"
import script from "./mailSettingGet.vue?vue&type=script&lang=js&"
export * from "./mailSettingGet.vue?vue&type=script&lang=js&"
import style0 from "./mailSettingGet.vue?vue&type=style&index=0&id=403df957&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403df957",
  null
  
)

export default component.exports